import { render, staticRenderFns } from "./DeliverClaim.vue?vue&type=template&id=4f935070&scoped=true"
import script from "./DeliverClaim.vue?vue&type=script&lang=js"
export * from "./DeliverClaim.vue?vue&type=script&lang=js"
import style0 from "./DeliverClaim.vue?vue&type=style&index=0&id=4f935070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f935070",
  null
  
)

export default component.exports